import { useInfiniteQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

interface IProps {
  limit?: number;
  search?: string;
}

export const useRecipientsQuery = ({ limit, search }: IProps) => {
  return useInfiniteQuery({
    queryKey: ['getRecipients', search],
    queryFn: async ({ pageParam = 0 }) => {
      return await Api.dictionaries.getRecipients({
        offset: pageParam,
        limit: limit || 0,
        search,
      });
    },
    getNextPageParam: (current, allPages) => {
      const count = allPages.length * (limit || 1);
      return count >= (current.total || 0) ? undefined : count;
    },
    enabled: !!search,
  });
};
